import React from 'react';

import { User, Team } from 'src/components/types';
import { CodeSearchResult } from 'src/types/search';

import ResultsPagination, {
  ResultsPaginationProps,
} from './results-pagination/results-pagination';
import Result from './search-result/search-result';

type ResultsProps = {
  currentPage: number;
  account: User | Team;
  codeSearchResults: CodeSearchResult[];
  displayRepoName: boolean;
  directoryPathClickable: boolean;
} & ResultsPaginationProps;

/* eslint @typescript-eslint/ban-types: "warn" */
export const Results: React.FC<ResultsProps> = props => {
  return (
    <>
      <div>
        {props.codeSearchResults.map((result, index) => (
          <Result
            key={
              (result.file.commit && result.file.commit.repository.full_name) +
              result.file.path
            }
            result={result}
            resultNum={index}
            pageNum={props.currentPage}
            accountUuid={props.account.uuid}
            displayRepoName={props.displayRepoName}
            directoryPathClickable={props.directoryPathClickable}
          />
        ))}
      </div>
      <ResultsPagination
        currentPage={props.currentPage}
        onSetPage={props.onSetPage}
        showPages={props.showPages}
        pages={props.pages}
        accountUuid={props.account.uuid}
      />
    </>
  );
};
